







import { Component, Vue } from 'vue-property-decorator'
import { mapGetters } from 'vuex'
import CardGatewayList from '@/components/card/CardGatewayList.vue'

@Component({
  components: {
    CardGatewayList,
  },
  computed: {},
})
export default class CardGateway extends Vue {
  get labelBreadcrumb(): string {
    return this.$t('breadcrumb.card_info_manage') as string
  }
}
